import React from 'react';
import {type BootStrapProps} from '../Bootstrap';
import {Container, type ContainerProps} from 'react-bootstrap';

export type BootStrapContainerProps = BootStrapProps<ContainerProps>;
export const BootstrapContainer = (props: BootStrapContainerProps) => <Container {...props as any} />;
